<template>
  <v-toolbar
    text
    dark
    color="light-blue darken-4"
    flat
    class="baseToolbar_v2"
    :style="[
      $vuetify.breakpoint.smAndUp ? secondToolbarStyles : { height: 'auto' }
    ]"
  >
    <slot name="toolbarContent"></slot>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    changeHeight: {
      type: Boolean,
      default: () => true
    },
    newHeight: {
      type: String,
      default: () => "73px"
    }
  },
  name: "BaseToolbarV2",
  computed: {
    secondToolbarStyles() {
      return {
        borderTop: "1px solid white !important",
        height: this.changeHeight ? this.newHeight : ""
      };
    }
  }
};
</script>

<style lang="scss">
@media screen and (max-width: 600px) {
  .baseToolbar_v2 {
    .v-toolbar__content {
      height: auto !important;
      flex-wrap: wrap !important;
    }
  }
}
</style>
